const MAX_COLS = 7;
const COLS_MIDDLE = Math.floor(MAX_COLS / 2);

function transformInstructions(targetWord, categories, letter, vowels, soft_words, hard_words) {
  const newVowels = transformVowels(vowels);
  const { softLetterSet, acc } = createSoftLetterCell(soft_words, letter, newVowels);
  const hardLetterSet = createHardLetterCell(hard_words, letter, acc);
  const targetCell = createTargetCell(letter);

  return { targetCell, categories, vowels: newVowels, softLetterSet, hardLetterSet };
}

function createTargetCell(letter) {
  return { ...letter, id: 0, row_index: 1, column_index: COLS_MIDDLE };
}

function transformVowels(vowels) {
  return vowels.map((letter, index, arr) => ({
    id: index + 1,
    letter,
    row_index: arr.length > 1 ? index : 1,
    column_index: COLS_MIDDLE,
  }));
}

function createSoftLetterCell(words, target, vowels) {
  if (target.letter === vowels[0].letter) {
    return words.reduce((prev, word) => {
      const targetIndex = word.indexOf(target.letter);
      const newSoftLetter = { ...prev };
      if (!newSoftLetter.softLetterSet[target.letter]) {
        newSoftLetter.softLetterSet[target.letter] = [];
      }
      newSoftLetter.softLetterSet[target.letter].push(createSoftLetterAsVowel(word, vowels[0].letter, targetIndex));
      newSoftLetter.acc = prev.acc + word.length - 2;
      return newSoftLetter;
    }, { softLetterSet: {}, acc: 0 });
  }

  const startingId = vowels.length + 1;
  return words.reduce((prev, word) => {
    const newSoftLetter = { ...prev };
    const targetIndex = word.indexOf(target.letter);
    const nextLetter = word.charAt(targetIndex + 1);
    if (!newSoftLetter.softLetterSet[nextLetter]) {
      newSoftLetter.softLetterSet[nextLetter] = [];
    }
    newSoftLetter.softLetterSet[nextLetter].push(createSoftLetterSingleCell(word, targetIndex, prev.acc, vowels));
    newSoftLetter.acc = prev.acc + word.length - 2;
    return newSoftLetter;
  }, { softLetterSet: {}, acc: startingId });
}

function createSoftLetterAsVowel(word, vowel, targetIndex) {
  const startPosition = getPositionFromLength(word.length, MAX_COLS);
  const splittedWord = word.split('');
  return {
    column_index: startPosition,
    vowel,
    word,
    cells: splittedWord.map((letter, index) => ({
      id: targetIndex + index,
      letter,
      row_index: 1,
      column_index: startPosition + index - 1,
    })),
  };
}

function createSoftLetterSingleCell(word, targetIndex, id, vowels) {
  const targetVowel = word.charAt(targetIndex + 1);
  const vowel = vowels.find(v => v.letter === targetVowel);
  const startPosition = getPositionFromLength(word.length, MAX_COLS);
  let splittedWord = word.split('').slice(targetIndex + 2);
  let initialLetters = [];
  if (targetIndex > 0) {
    initialLetters = word.split('').slice(0, targetIndex);
    splittedWord = [...initialLetters, ...splittedWord];
  }
  return {
    column_index: startPosition + initialLetters.length,
    vowel: targetVowel,
    word,
    cells: splittedWord.map((letter, index) => {
      let column_index;
      if (initialLetters.length > index) {
        column_index = startPosition - initialLetters.length + index;
      } else {
        column_index = initialLetters.length + index + startPosition + 1;
      }
      return {
        id: id + index,
        letter,
        row_index: vowel.row_index,
        column_index,
      };
    }),
  };
}

function createHardLetterCell(words, target, startingId) {
  const { hardLetterCell } = words.reduce((prev, word) => {
    const newhardLetterCell = { ...prev };
    const targetIndex = word.indexOf(target.letter);
    newhardLetterCell.hardLetterCell.push({
      cells: createHardLetterSingleCell(word, targetIndex, newhardLetterCell.acc),
    });
    newhardLetterCell.acc += word.length;
    return newhardLetterCell;
  }, { hardLetterCell: [], acc: startingId });
  return hardLetterCell;
}

function createHardLetterSingleCell(word, targetIndex, id) {
  const startPosition = getPositionFromLength(word.length, MAX_COLS);
  const splittedWord = word.split('').slice(targetIndex + 1);

  return splittedWord.map((letter, index) => ({
    id: id + index,
    letter,
    row_index: 1,
    column_index: startPosition + index,
  }));
}

function getPositionFromLength(length, maxLength) {
  const shift = length % 2 === 0 ? 2 : 1;
  return Math.floor(maxLength / 2) - Math.floor(length / 2) + shift;
}
export default transformInstructions;
